import React from 'react';
import {classes, style} from './doppe-action-type-testimonial-widget.st.css';
import {DoppeActionTypeTestimonial} from '../doppe-action-type-testimonial';
import {DoppeActionGoalType, DoppeActionType} from '../../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeActionTypeWidgetInnerDescription
} from '../../../components/doppe-action-type-widget-inner-description/doppe-action-type-widget-inner-description';
import {IDoppeViewerActionContext} from '../../../doppe-sdk';
import {
    DoppeActionTypeWidgetInnerTitle
} from '../../../components/doppe-action-type-widget-inner-title/doppe-action-type-widget-inner-title';
import {
    DoppeActionTypeWidgetLayout
} from '../../../components/doppe-action-type-widget-layout/doppe-action-type-widget-layout';
import {
    DoppeActionTypeWidgetContentLayoutNewWrapperSectionsAndButtons
} from '../../../components/doppe-action-type-widget-content-layout-new-wrapper-sections-and-buttons/doppe-action-type-widget-content-layout-new-wrapper-sections-and-buttons';
import {
    DoppeActionTypeWidgetContentDate
} from '../../../components/doppe-action-type-widget-content-date/doppe-action-type-widget-content-date';
import {
    DoppeActionTypeRatingView
} from '../../../components/doppe-action-type-rating-view/doppe-action-type-rating-view';
import {FlexLayout, WixImageView} from '@wix/devzai-common-client';
import {flexColumn, flexRowAlignToCenter, ImageViewResizeMode} from '@wix/devzai-utils-react';

export const DoppeActionTypeTestimonialWidget = React.memo(function DoppeActionTypeTestimonialWidget(
    props: DoppeActionType.WidgetProps<DoppeActionTypeTestimonial.ActionSettings>
) {
    const {
        actionContext,

        className,
        ...htmlAttributes
    } = props;

    return (
        <DoppeActionTypeWidgetLayout
            {...htmlAttributes}
            className={style(classes.root, {}, className)}
            actionContext={actionContext}
        >
            <DoppeActionTypeTestimonialWidgetInner
                actionContext={actionContext}
                reportGoalAchieved={(goalType) => {
                    actionContext.reportGoalAchieved({
                        goalType: goalType,
                    })
                }}
                actionSettings={actionContext.action.settings}
            />
        </DoppeActionTypeWidgetLayout>
    );
});


export const DoppeActionTypeTestimonialWidgetInner = React.memo(function DoppeActionTypeTestimonialWidgetInner(
    props: {
        actionSettings: DoppeActionTypeTestimonial.ActionSettings;
        reportGoalAchieved: (goalType: DoppeActionGoalType) => void;
        actionContext: IDoppeViewerActionContext;
        noContentTopPadding?: boolean;
        listItemId?: string;
    }
) {
    const {
        actionSettings,
        reportGoalAchieved,
        actionContext,
        noContentTopPadding,
        listItemId
    } = props;


    const {
        profileMedia,
        date,
        description,
        tagLine,
        mainQuote,
        name,
        rating,
    } = actionSettings;

    return (
        <>
            <DoppeActionTypeWidgetContentLayoutNewWrapperSectionsAndButtons
                sections={actionSettings.sections}
                buttons={actionSettings.ctaButtons}
                actionContext={actionContext}
                reportGoalAchieved={reportGoalAchieved}
                noContentTopPadding={noContentTopPadding}
                buttonsSettings={{
                    listItemId: listItemId
                }}
            >
                <div
                    className={style(classes.detailsSection, {}, flexRowAlignToCenter())}
                >
                    {
                        profileMedia ?
                            <WixImageView
                                className={style(classes.profileImage, FlexLayout.noShrink)}
                                src={profileMedia}
                                resizeMode={ImageViewResizeMode.Cover}
                                positionHorizontal={'center'}
                                positionVertical={'center'}
                            />
                            :
                            null
                    }
                    <div
                        className={style(classes.detailsTexts, {}, flexColumn())}
                    >
                        <DoppeActionTypeWidgetInnerTitle>
                            {name}
                        </DoppeActionTypeWidgetInnerTitle>
                        <DoppeActionTypeWidgetInnerDescription
                        >
                            {tagLine}
                        </DoppeActionTypeWidgetInnerDescription>
                        <DoppeActionTypeWidgetContentDate>{date}</DoppeActionTypeWidgetContentDate>
                    </div>

                </div>
                <DoppeActionTypeWidgetInnerTitle
                    className={style(classes.mainQuote, {})}
                >
                    {mainQuote}
                </DoppeActionTypeWidgetInnerTitle>
                <DoppeActionTypeWidgetInnerDescription
                    className={style(classes.description, {})}
                >
                    {description}
                </DoppeActionTypeWidgetInnerDescription>
                <DoppeActionTypeRatingView
                    className={style(classes.rating, {})}
                    rating={rating}
                />
            </DoppeActionTypeWidgetContentLayoutNewWrapperSectionsAndButtons>
        </>
    );
});







